import React from 'react';
import { CampaignRune } from './CampaignRune';

export const CharacterAvatar = ({ char, emojiSize, size, color, fontFamily }) => {
  const initial = (char.name || '?').trim().charAt(0).toUpperCase();
  const letterSize = emojiSize || (size != null ? `${size * 0.60}px` : '1.6rem');
  const fillColor = color || 'currentColor';
  const strokeWidth = size ? Math.max(0.6, size * 0.015) : 1;
  const wrapperSize = size != null ? size : '100%';
  // The rune backdrop nearly fills the wrapper but leaves a small inset
  // so the letter doesn't crowd the rune's outer ring.
  const runeSize = size != null ? size * 0.92 : '92%';
  return (
    <div style={{
      position: 'relative',
      width: wrapperSize,
      height: wrapperSize,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {/* Rune backdrop — low-opacity palette-tinted sigil behind the letter */}
      <div style={{
        position: 'absolute', inset: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        opacity: 0.32,
      }}>
        <CampaignRune
          name="grategrate"
          size={runeSize}
          color={fillColor}
          glow={0}
        />
      </div>
      {/* Letter — illuminated drop cap on top of the rune */}
      <span style={{
        position: 'relative',
        fontFamily: fontFamily || 'Georgia, serif',
        fontSize: letterSize,
        fontWeight: 700,
        lineHeight: 1,
        color: fillColor,
        WebkitTextStroke: `${strokeWidth}px rgba(0,0,0,0.55)`,
        textShadow: `1px 1px 0 rgba(0,0,0,0.35)`,
      }}>{initial}</span>
    </div>
  );
};
